export {
  setInteractionModality,
  getInteractionModality,
  isFocusVisible,
  getPointerType,
  addWindowFocusTracking,
  useInteractionModality,
  useFocusVisibleListener,
  type FocusVisibleHandler,
  type Modality
} from '../../../src/interactions/useFocusVisible';
